import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Sparkles, ExternalLink, Wallet, FileText } from 'lucide-react';

const ctas = [
  { label: 'Contribute Crowdfund, Become OG', href: '/crowdfund', external: false, primary: true, icon: Sparkles },
  { label: 'Join Discord, Grab OG Rewards', href: 'https://discord.gg/rRBSnQsxJu', external: true, primary: false, icon: ExternalLink },
  { label: 'View Whitepaper V2', href: '/whitepaper', external: false, primary: false, icon: FileText },
  { label: 'Connect Wallet, Preview Portal', href: '/mint', external: false, primary: false, icon: Wallet },
];

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-3 md:mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-400">
            No VC — Only You and Us Creating the Timeline
          </h2>
          <p className="text-sm md:text-base text-gray-400 max-w-xl mx-auto">
            Grants + community crowdfund for LP. Target $25–75k initial liquidity. Join the fair launch.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.35 }}
          className="grid sm:grid-cols-2 gap-3 md:gap-4"
        >
          {ctas.map((cta) => {
            const Icon = cta.icon;
            const base = 'px-4 py-3 md:px-6 md:py-4 rounded-xl font-semibold text-sm md:text-base flex items-center justify-center gap-2 min-h-[48px]';
            const primary = 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/40';
            const secondary = 'bg-slate-800/60 border-2 border-purple-500/40 text-purple-200 hover:border-purple-500/60';

            const content = (
              <>
                <Icon className="w-4 h-4 md:w-5 md:h-5 shrink-0" />
                <span>{cta.label}</span>
              </>
            );

            if (cta.external) {
              return (
                <motion.a
                  key={cta.label}
                  href={cta.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${base} ${secondary}`}
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.99 }}
                >
                  {content}
                </motion.a>
              );
            }
            return (
              <Link key={cta.label} to={cta.href}>
                <motion.span
                  className={`inline-flex w-full ${base} ${cta.primary ? primary : secondary}`}
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.99 }}
                >
                  {content}
                </motion.span>
              </Link>
            );
          })}
        </motion.div>

        <p className="mt-6 md:mt-8 text-center text-xs md:text-sm text-gray-500">
          <Link to="/whitepaper" className="text-purple-400 hover:text-purple-300 inline-flex items-center gap-1">
            <FileText className="w-3.5 h-3.5 md:w-4 md:h-4" />
            Download Whitepaper (Lite)
          </Link>
        </p>
      </div>
    </section>
  );
}
